import React, { useEffect } from 'react';
import { assertNoMock } from '../lib/assertions';

const DevGuard = () => {
  useEffect(() => {
    // Run assertion after component mounts
    assertNoMock();
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default DevGuard;

